export const returnCurrencyYear = (currencyRates, fy) =>
  currencyRates?.[fy] ??
  currencyRates?.[
    Object.keys(currencyRates).sort(
      (a, b) => parseInt(b.slice(2)) - parseInt(a.slice(2)),
    )[0]
  ];

export const returnCountryObject = (currencyYear, countryId) =>
  currencyYear?.find((currency) => currency.countryId === countryId);
export const returnCurrencyObject = (currencyRates, country, fy) => {
  const currencyRateFY = returnCurrencyYear(currencyRates, fy);
  const currencyObject = returnCountryObject(currencyRateFY, country);
  return currencyObject;
};
export const convertToEur = (currencyObj, value) =>
  currencyObj?.currencyCode !== 'EUR'
    ? `${parseFloat((value * (currencyObj?.currencyRate || 1)).toFixed(1))}`
    : `${value}`;
